export default __webpack_public_path__ + "static/media/9.2fe09c5a.jpg";